import {useCallback} from "react";
import {
	DateField,
	SelectField
} from "~/components/Forms";
import {strToTime} from "~/utils";
import {
	slipTypeOptions,
	calcTypeOptions,
	objectOptions
} from "../../constants";

function SalarySlipSearchBar({onChange}) {

	const slipTypeFilter = [{ value: '', label: 'Tất cả loại phiếu' }, ...slipTypeOptions];
	const calcTypeFilter = [{ value: '', label: 'Tất cả loại tính' }, ...calcTypeOptions];
	const objectFilter   = [{ value: '', label: 'Tất cả đối tượng' }, ...objectOptions];

	const handleTimeChange = useCallback((value) => {
		value = strToTime(value);
		if(onChange) onChange('time', value);
	}, [onChange]);

	const handleChange = useCallback((key, value) => {
		if(onChange) onChange(key, value);
	}, [onChange]);

	return (
		<div className="search-bar">
			<div className="container">
				<form className="form" autoComplete="off">
					<DateField name="time" picker="month" onChange={handleTimeChange}/>
					<SelectField placeholder="Loại phiếu" options={slipTypeFilter} onChange={(value) => handleChange('slipType', value)} />
					<SelectField placeholder="Loại tính" options={calcTypeFilter} onChange={(value) => handleChange('calcType', value)} />
					<SelectField placeholder="Đối tượng" options={objectFilter} onChange={(value) => handleChange('object', value)} />
				</form>
			</div>
		</div>
	)
}

export default SalarySlipSearchBar;
